import { createReducer } from 'reduxsauce';

import { UnsafeReturnType } from '../types';
import { ITestingState, testingTypes } from './types';
import * as testingActions from './actions';

/* ------------- Types and Action Creators ------------- */

/* ------------- Initial State ------------- */
const INITIAL_STATE: ITestingState = {
  testings: [],
};

/* ------------- Selectors ------------- */

/* ------------- Reducers ------------- */
interface IActionHandler<T> {
  (state: ITestingState, action: UnsafeReturnType<T>): ITestingState;
}

const getTestRegistrations: IActionHandler<typeof testingActions['getTestRegistrations']> = (state, { payload }) => ({
  ...state,
});

const getTestResults: IActionHandler<typeof testingActions['getTestResults']> = (state, { payload }) => ({
  ...state,
});

const getTestDetailInfo: IActionHandler<typeof testingActions['getTestDetailInfo']> = (state, { payload }) => ({
  ...state,
});

/* ------------- Hookup Reducers To Types ------------- */
const HANDLERS = {
  [testingTypes.GET_TEST_REGISTRATIONS]: getTestRegistrations,
  [testingTypes.GET_TEST_RESULTS]: getTestResults,
  [testingTypes.GET_TEST_DETAIL_INFO]: getTestDetailInfo,
};

const testingReducer = createReducer<ITestingState>(INITIAL_STATE, HANDLERS);

/* ------------- export ------------- */
export { testingReducer, testingTypes, testingActions };
